import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleEyesYeux8 = customSolarIconWrapper(<g transform="translate(93 115.5)">
	<path d="M42.2998 22C42.2998 22 31.2998 14 31.2998 8C31.2998 3 35.2998 0 38.7998 0C40.7998 0 42.2998 2 42.2998 2C42.2998 2 43.7998 0 45.7998 0C49.2998 0 53.2998 3 53.2998 8C53.2998 14 42.2998 22 42.2998 22Z" fill="#202020" />
	<path d="M11 24.1C11 24.1 0 16.1 0 10.1C0 5.09998 4 2.09998 7.5 2.09998C9.5 2.09998 11 4.09998 11 4.09998C11 4.09998 12.5 2.09998 14.5 2.09998C18 2.09998 22 5.09998 22 10.1C22 16.1 11 24.1 11 24.1Z" fill="#202020" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleEyesYeux8;
